import { render } from "./DefectiveItemCauseForm.vue?vue&type=template&id=3b372351"
import script from "./DefectiveItemCauseForm.vue?vue&type=script&lang=js"
export * from "./DefectiveItemCauseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__